export default function debounce(fn, interval = 500) {
    let timer = null;

    function debounced(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => {
            fn(...args);
        }, interval);
    }

    debounced.cancel = (fnLoader = () => {}) => {
        fnLoader(false)
        clearTimeout(timer);
    };

    return debounced;
};
